import { render, staticRenderFns } from "./updateUserInfo.vue?vue&type=template&id=219a66d8&scoped=true&"
import script from "./updateUserInfo.vue?vue&type=script&lang=js&"
export * from "./updateUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateUserInfo.vue?vue&type=style&index=0&id=219a66d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a66d8",
  null
  
)

export default component.exports